import { WxRequest as request } from '../../lib/request';
import { DataDesc } from '../wxDataDesc';
import { Store } from 'vuex';
import VueI18n from 'vue-i18n';
import { WxIBlobDataItem } from '../wxDataDesc/wxIBlobDataItem';

export class DataModule {
    private xStore!: Store<any>;
    private xDataset!: DataDesc;

    constructor(store?: Store<any>, dataDesc?: DataDesc) {
        if (store) {
            this.store = store;
        }
        if (dataDesc) {
            this.dataSet = dataDesc;
        }
    }

    public get store() {
        return this.xStore;
    }

    public set store(store: Store<any>) {
        this.xStore = store;
    }

    public get dataSet() {
        return this.xDataset;
    }
    public set dataSet(dataset: DataDesc) {
        this.xDataset = dataset;
    }

    public get dataLoading() {
        return !this.xDataset ? false : this.xDataset.loading;
    }

    public set dataLoading(loading: boolean) {
        if (this.xDataset) {
            this.xDataset.loading = loading;
        }
    }

    public get dataDefault() {
        return this.dataSet.default;
    }

    public get masterItem() {
        return this.dataSet.record;
    }

    public set masterItem(item: any) {
        this.dataSet.record = item;
    }

    public get masterList() {
        return this.dataSet.records;
    }

    public set masterList(items: object[]) {
        this.dataSet.records = items;
    }

    public initialize() {
        if (this.xDataset) {
            this.dataSet.configure();
        }
    }

    public async selectMaster() {
        this.dataLoading = true;
        const res = await request().execute(this.dataSet.selectProc);
        this.dataLoading = false;
        this.masterList = res.data;
        return res.data;
    }

    public async updateMaster(item: object, isInsert: boolean, i18n: VueI18n) {
        this.dataLoading = true;
        const res = await request().execute(this.dataSet.updateProc, item);
        this.dataLoading = false;
        const success = !!res.data && res.data instanceof Array && res.data.length === 1;
        if (success) {
            this.dataSet.insertOrUpdate(res.data[0], isInsert, i18n);
            if (this.store) {
                this.store.commit('addMessage', this.dataSet.message, { root: true });
            }
        }
        return success;
    }

    public async deleteMaster(item: object, i18n: VueI18n) {
        this.dataLoading = true;
        const res = await request().execute(this.dataSet.deleteProc, item);
        this.dataLoading = false;
        if (this.store) {
            this.store.commit('addMessage', i18n.t('$common.ITEM_DELETED', [this.dataSet.caption]), { root: true }); // TODO: i18n
        }
        this.masterList = res.data;
        return res.data;
    }

    public async selectBlobData(item: WxIBlobDataItem) {
        const res = await request().execute('StdSelectBlobData', item);
        const success = !!res.data && res.data instanceof Array && res.data.length === 1;
        if (success) {
            const augmentedItem: any = {};
            augmentedItem[this.dataSet.primaryKey] = item.REFERENCEGUID;
            augmentedItem[item.CONTEXT] = res.data[0].CONTENTS;
            this.dataSet.insertOrUpdate(augmentedItem, false);
        }
    }
}
